/*
  Tema novo da Klassey: comportamento das telas da planta aprovada (Figma).
  Menu, busca rápida (só produtos com anúncio no Mercado Livre), carrosséis com setas,
  filtro com gaveta, galeria e "Ver mais" da PDP. Sem dependências.
*/
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var raf = window.requestAnimationFrame || function (f) { setTimeout(f, 16); };
  var travas = 0;
  function trava(on) {
    travas = Math.max(0, travas + (on ? 1 : -1));
    document.documentElement.classList.toggle('kt-travado', travas > 0);
  }
  function real(v) {
    return 'R$ ' + v.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function semAcento(s) {
    return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  }

  // ---------- cabeçalho fixo: a barra de filtro encosta embaixo dele ----------
  // o cabeçalho rola com a página; a barra de filtro cola no topo da tela (pedido de 01/10)
  function alturaCab() { document.documentElement.style.setProperty('--kt-topo', '0px'); }
  alturaCab();
  window.addEventListener('resize', alturaCab, { passive: true });

  // ---------- menu ----------
  var menu = $('[data-kt-menu]');
  var voltaFoco = null;
  function inerte(on) {
    ['main-content'].forEach(function (id) { var el = document.getElementById(id); if (el) { if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert'); } });
  }
  function abreMenu(on) {
    if (!menu) return;
    if (on) voltaFoco = document.activeElement; else if (voltaFoco && voltaFoco.focus) setTimeout(function () { voltaFoco.focus(); }, 0);
    inerte(on);
    var b = $('[data-kt-menu-abrir]'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    menu.classList.toggle('is-aberto', on);
    menu.setAttribute('aria-hidden', on ? 'false' : 'true');
    trava(on);
    if (on) { var f = $('[data-kt-menu-fechar]', menu); if (f) f.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-kt-menu-abrir]')) { e.preventDefault(); abreMenu(true); }
    else if (e.target.closest('[data-kt-menu-fechar]')) { e.preventDefault(); abreMenu(false); }
    else if (e.target.closest('[data-kt-marcas-abrir]')) {
      var b = e.target.closest('[data-kt-marcas-abrir]');
      var lista = $('[data-kt-marcas]');
      var aberto = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', aberto ? 'false' : 'true');
      if (lista) lista.hidden = aberto;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if (menu && menu.classList.contains('is-aberto')) abreMenu(false); fechaGavetas(); }
  });

  // ---------- busca rápida ----------
  var anuncios = {};
  try { anuncios = JSON.parse(($('#kt-anuncios') || {}).textContent || '{}'); } catch (e) {}
  $$('[data-kt-busca]').forEach(function (form) {
    var input = $('input[name="q"]', form);
    var caixa = $('[data-kt-sugestoes]', form);
    if (!input || !caixa) return;
    var timer, ultimo = '';
    function fecha() { caixa.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function procura() {
      var q = input.value.trim();
      if (q.length < 2) { fecha(); return; }
      if (q === ultimo && !caixa.hidden) return;
      ultimo = q;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (input.value.trim() !== q) return;
          var itens = (((d.resources || {}).results || {}).products || []).filter(function (p) { return anuncios[p.handle]; });
          itens.sort(function (a, b) { return anuncios[a.handle][1] - anuncios[b.handle][1]; });
          caixa.innerHTML = '';
          itens.slice(0, 5).forEach(function (p) {
            var a = document.createElement('a');
            a.className = 'kt-sugestoes__item';
            a.href = '/products/' + p.handle;
            var img = document.createElement('img');
            img.alt = '';
            img.loading = 'lazy';
            if (p.image) img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            var txt = document.createElement('span');
            var nome = document.createElement('span'); nome.className = 'kt-sugestoes__nome'; nome.textContent = p.title;
            var preco = document.createElement('span'); preco.className = 'kt-sugestoes__preco'; preco.textContent = anuncios[p.handle][0];
            txt.appendChild(nome); txt.appendChild(document.createElement('br')); txt.appendChild(preco);
            a.appendChild(img); a.appendChild(txt);
            caixa.appendChild(a);
          });
          if (!itens.length) {
            var v = document.createElement('p'); v.className = 'kt-sugestoes__vazio';
            v.textContent = 'Nenhum perfume com anúncio para "' + q + '".';
            caixa.appendChild(v);
          }
          var todos = document.createElement('a');
          todos.className = 'kt-sugestoes__todos';
          todos.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
          todos.textContent = 'Ver todos os resultados';
          caixa.appendChild(todos);
          caixa.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(fecha);
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(procura, 220); });
    input.addEventListener('focus', function () { if (caixa.childNodes.length && input.value.trim().length > 1) { caixa.hidden = false; } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) fecha(); });
  });
  var abreBusca = $('[data-kt-busca-abrir]');
  if (abreBusca) {
    abreBusca.addEventListener('click', function (e) {
      var area = $('[data-kt-busca-area]');
      if (!area) return;
      e.preventDefault();
      area.hidden = false;
      alturaCab();
      var i = $('input[name="q"]', area); if (i) i.focus();
    });
  }

  // ---------- carrosséis ----------
  $$('[data-kt-trilho]').forEach(function (trilho) {
    var wrap = trilho.parentNode;
    var ant = $('[data-kt-seta="-1"]', wrap), prox = $('[data-kt-seta="1"]', wrap);
    function setas() {
      if (ant) ant.disabled = trilho.scrollLeft < 4;
      if (prox) prox.disabled = trilho.scrollLeft + trilho.clientWidth > trilho.scrollWidth - 4;
    }
    [ant, prox].forEach(function (b) {
      if (b) b.addEventListener('click', function () {
        trilho.scrollBy({ left: parseInt(b.getAttribute('data-kt-seta'), 10) * trilho.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
    trilho.addEventListener('scroll', setas, { passive: true });
    window.addEventListener('resize', setas, { passive: true });
    setas();
  });

  // ---------- filtro ----------
  var ROT = {
    linha: { arabes: 'Árabes', nicho: 'Nicho', corpo: 'Corpo' },
    faixa: { 'ate-250': 'Até R$ 250', '250-400': 'R$ 250 a 400', '400-1000': 'R$ 400 a 1.000', '1000-mais': 'Acima de R$ 1.000' },
    genero: { unissex: 'Unissex', masculino: 'Masculino', feminino: 'Feminino' },
    familia: { amadeirado: 'Amadeirado', ambar: 'Âmbar', 'doce-gourmand': 'Doce', floral: 'Floral', especiado: 'Especiado', oud: 'Oud', aquatico: 'Aquático', citrico: 'Cítrico', tabaco: 'Tabaco', couro: 'Couro' }
  };
  var GRUPOS = [['linha', 'Linha'], ['faixa', 'Preço'], ['genero', 'Gênero'], ['marca', 'Marca'], ['familia', 'Família olfativa']];
  var PASSO = 24, MARCAS = 8;
  var gavetasAbertas = [];
  function fechaGavetas() { gavetasAbertas.slice().forEach(function (f) { f(); }); }

  $$('[data-kt-filtro]').forEach(function (raiz) {
    var grade = $('[data-kt-grade]', raiz);
    if (!grade) return;
    var cards = $$('.kt-card', grade).map(function (el) {
      return { el: el, linha: el.dataset.linha, faixa: el.dataset.faixa, genero: el.dataset.genero, marca: el.dataset.marca,
        familia: (el.dataset.familia || '').split(' ').filter(Boolean), preco: parseFloat(el.dataset.preco) || 0, nome: el.dataset.nome || '' };
    });
    var estado = { linha: [], faixa: [], genero: [], marca: [], familia: [] };
    var preset = { linha: raiz.dataset.presetLinha, faixa: raiz.dataset.presetFaixa };
    var passo = parseInt(raiz.dataset.limite, 10) || PASSO;
    var verLink = raiz.dataset.verLink || '';
    var ordem = 'preco-asc', limite = passo, marcasAbertas = false;
    var unidade = raiz.dataset.unidade || 'perfume';
    var gaveta = $('[data-kt-gaveta]', raiz), fundo = $('[data-kt-gaveta-fundo]', raiz);

    function casa(c, dim, vals) {
      if (!vals.length) return true;
      if (dim === 'familia') return c.familia.some(function (f) { return vals.indexOf(f) > -1; });
      return vals.indexOf(c[dim]) > -1;
    }
    function filtra(exceto) {
      return cards.filter(function (c) { return GRUPOS.every(function (g) { return g[0] === exceto || casa(c, g[0], estado[g[0]]); }); });
    }
    function valores(dim) {
      var n = {};
      cards.forEach(function (c) { (dim === 'familia' ? c.familia : [c[dim]]).forEach(function (v) { if (v) n[v] = (n[v] || 0) + 1; }); });
      if (ROT[dim]) return Object.keys(ROT[dim]).filter(function (v) { return n[v]; });
      return Object.keys(n).sort(function (a, b) { return n[b] - n[a] || a.localeCompare(b); });
    }
    function conta(dim, v) { return filtra(dim).filter(function (c) { return casa(c, dim, [v]); }).length; }
    function ativos() { return GRUPOS.reduce(function (t, g) { return t + estado[g[0]].length; }, 0); }
    function rotulo(dim, v) { return (ROT[dim] && ROT[dim][v]) || v; }
    function palavra(lista, n) {
      var soCorpo = lista.length && lista.every(function (c) { return c.linha === 'corpo'; });
      if (soCorpo || unidade === 'item') return n === 1 ? 'item' : 'itens';
      return n === 1 ? 'perfume' : 'perfumes';
    }

    function desenhaGrade() {
      var lista = filtra().sort(function (a, b) {
        if (ordem === 'preco-desc') return b.preco - a.preco;
        if (ordem === 'nome') return a.nome.localeCompare(b.nome);
        return a.preco - b.preco;
      });
      var mostra = {};
      lista.forEach(function (c, i) { grade.appendChild(c.el); if (i < limite) mostra[cards.indexOf(c)] = 1; });
      cards.forEach(function (c, i) { c.el.hidden = !mostra[i]; });
      var p = palavra(lista, lista.length);
      $$('[data-kt-n]', raiz).forEach(function (el) { el.textContent = lista.length + ' ' + p; });
      $$('[data-kt-n-sub]', raiz).forEach(function (el) { el.textContent = lista.length + ' ' + p + ' ' + el.dataset.ktNSub; });
      var ver = $('[data-kt-ver-n]', raiz); if (ver) ver.textContent = 'Ver ' + lista.length + ' ' + p;
      var vazio = $('[data-kt-vazio]', raiz); if (vazio) vazio.hidden = lista.length > 0;
      var mais = $('[data-kt-mais]', raiz), resto = lista.length - limite;
      if (mais) {
        mais.parentNode.hidden = resto <= 0;
        mais.textContent = verLink ? 'Ver mais' : 'Mostrar mais ' + Math.min(resto, passo);
      }
    }
    function desenhaGrupos() {
      var caixa = $('[data-kt-grupos]', raiz);
      if (!caixa) return;
      caixa.innerHTML = '';
      GRUPOS.forEach(function (g) {
        var dim = g[0], vals = valores(dim);
        if (dim === 'marca' || dim === 'familia') {
          var n0 = {};
          vals.forEach(function (v) { n0[v] = conta(dim, v); });
          vals = vals.filter(function (v) { return n0[v] || estado[dim].indexOf(v) > -1; })
            .sort(function (a, b) { return n0[b] - n0[a] || a.localeCompare(b); });
        }
        if (vals.length < 2 && !estado[dim].length) return;
        var grupo = document.createElement('div'); grupo.className = 'kt-grupo';
        var t = document.createElement('p'); t.className = 'kt-grupo__titulo'; t.textContent = g[1]; grupo.appendChild(t);
        var ops = document.createElement('div'); ops.className = 'kt-grupo__opcoes';
        var escondidas = 0;
        vals.forEach(function (v, i) {
          var on = estado[dim].indexOf(v) > -1, n = conta(dim, v);
          if (dim === 'marca' && !marcasAbertas && i >= MARCAS && !on) { escondidas++; return; }
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'kt-chip' + (on ? ' is-on' : '');
          b.disabled = !n && !on; b.setAttribute('aria-pressed', on);
          b.dataset.ktDim = dim; b.dataset.ktValor = v;
          var s = document.createElement('span'); s.textContent = rotulo(dim, v);
          var sm = document.createElement('small'); sm.textContent = n;
          b.appendChild(s); b.appendChild(sm); ops.appendChild(b);
        });
        if (escondidas) {
          var m = document.createElement('button'); m.type = 'button'; m.className = 'kt-grupo__mais';
          m.textContent = '+ ' + escondidas + ' marcas'; m.dataset.ktMarcas = '1'; ops.appendChild(m);
        }
        grupo.appendChild(ops); caixa.appendChild(grupo);
      });
    }
    function desenhaAtivos() {
      var caixa = $('[data-kt-ativos]', raiz);
      if (caixa) {
        caixa.innerHTML = '';
        GRUPOS.forEach(function (g) {
          estado[g[0]].forEach(function (v) {
            if ($('[data-kt-atalho="' + g[0] + '"][data-kt-valor="' + v + '"]', raiz)) return;
            if (g[0] === 'linha' && v === preset.linha) return;   // a linha da própria coleção conta, mas não vira chip (planta)
            var b = document.createElement('button'); b.type = 'button'; b.className = 'kt-chip is-on';
            b.dataset.ktDim = g[0]; b.dataset.ktValor = v; b.textContent = rotulo(g[0], v) + ' ✕';
            caixa.appendChild(b);
          });
        });
      }
      var n = ativos();
      var bf = $('[data-kt-filtrar]', raiz); if (bf) bf.textContent = n ? 'Filtrar · ' + n : 'Filtrar';
      $$('[data-kt-atalho]', raiz).forEach(function (b) {
        var on = estado[b.dataset.ktAtalho].indexOf(b.dataset.ktValor) > -1;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      });
    }
    function url() {
      if (raiz.dataset.url !== 'sim') return;
      try {
        var u = new URL(location.href);
        GRUPOS.forEach(function (g) {
          u.searchParams.delete(g[0]);
          var vals = estado[g[0]];
          var igualPreset = preset[g[0]] && vals.length === 1 && vals[0] === preset[g[0]];
          if (vals.length && !igualPreset) u.searchParams.set(g[0], vals.join(','));
        });
        history.replaceState(history.state, '', u.toString());
      } catch (e) {}
    }
    function linkComFiltro() {
      var u = new URL(verLink, location.origin);
      GRUPOS.forEach(function (g) { if (estado[g[0]].length) u.searchParams.set(g[0], estado[g[0]].join(',')); });
      return u.pathname + u.search;
    }
    function tudo(semUrl) { desenhaGrade(); desenhaGrupos(); desenhaAtivos(); if (!semUrl) url(); }
    function alterna(dim, v) {
      var i = estado[dim].indexOf(v);
      if (i > -1) estado[dim].splice(i, 1); else estado[dim].push(v);
      limite = passo; tudo();
    }

    var focoAntes = null;
    function abre() {
      if (!gaveta) return;
      focoAntes = document.activeElement;
      setTimeout(function () { var f = $('[data-kt-fechar]', gaveta); if (f) f.focus(); }, 60);
      gaveta.hidden = false; fundo.hidden = false;
      raf(function () { raf(function () { gaveta.classList.add('is-aberto'); fundo.classList.add('is-aberto'); }); });
      trava(true); gavetasAbertas.push(fecha);
    }
    function fecha() {
      if (!gaveta || gaveta.hidden) return;
      gaveta.classList.remove('is-aberto'); fundo.classList.remove('is-aberto');
      if (focoAntes && focoAntes.focus) focoAntes.focus();
      trava(false); gavetasAbertas = gavetasAbertas.filter(function (f) { return f !== fecha; });
      setTimeout(function () { if (!gaveta.classList.contains('is-aberto')) { gaveta.hidden = true; fundo.hidden = true; } }, 460);
    }

    raiz.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !raiz.contains(b)) return;
      if (b.hasAttribute('data-kt-filtrar')) abre();
      else if (b.hasAttribute('data-kt-fechar')) fecha();
      else if (b.hasAttribute('data-kt-limpar')) { GRUPOS.forEach(function (g) { estado[g[0]] = []; }); limite = passo; tudo(); }
      else if (b.hasAttribute('data-kt-mais')) {
        if (verLink) { location.href = linkComFiltro(); return; }
        limite += passo; desenhaGrade();
      }
      else if (b.dataset.ktMarcas) { marcasAbertas = true; desenhaGrupos(); }
      else if (b.dataset.ktAtalho) alterna(b.dataset.ktAtalho, b.dataset.ktValor);
      else if (b.dataset.ktDim) alterna(b.dataset.ktDim, b.dataset.ktValor);
    });
    if (fundo) fundo.addEventListener('click', fecha);
    var sel = $('[data-kt-ordem]', raiz);
    if (sel) sel.addEventListener('change', function () { ordem = sel.value; desenhaGrade(); });

    if (preset.linha) estado.linha = [preset.linha];
    if (preset.faixa) estado.faixa = [preset.faixa];
    if (raiz.dataset.url === 'sim') {
      try {
        var q = new URLSearchParams(location.search);
        GRUPOS.forEach(function (g) {
          var v = q.get(g[0]);
          if (v) estado[g[0]] = v.split(',').filter(function (x) { return valores(g[0]).indexOf(x) > -1; });
        });
      } catch (e) {}
    }
    tudo(true);
    raiz.classList.add('is-pronto');
  });

  // ---------- busca: resultados do menor para o maior preço ----------
  $$('[data-kt-ordena-preco]').forEach(function (g) {
    $$('.kt-card', g).sort(function (a, b) { return parseFloat(a.dataset.preco) - parseFloat(b.dataset.preco); })
      .forEach(function (c) { g.appendChild(c); });
  });

  // ---------- PDP ----------
  $$('[data-kt-fotos]').forEach(function (fotos) {
    var pontos = $$('[data-kt-ponto]', fotos.parentNode);
    if (!pontos.length) return;
    pontos.forEach(function (p, i) { p.addEventListener('click', function () { fotos.scrollTo({ left: i * fotos.clientWidth, behavior: 'smooth' }); }); });
    fotos.addEventListener('scroll', function () {
      var i = Math.round(fotos.scrollLeft / fotos.clientWidth);
      pontos.forEach(function (p, j) { p.classList.toggle('is-on', i === j); });
    }, { passive: true });
  });
  $$('[data-kt-vermais]').forEach(function (b) {
    var t = document.getElementById(b.getAttribute('aria-controls'));
    if (!t) return;
    raf(function () { if (t.scrollHeight <= t.clientHeight + 2) b.hidden = true; });
    b.addEventListener('click', function () {
      var aberto = t.classList.toggle('is-aberto');
      b.textContent = aberto ? 'Ver menos' : 'Ver mais';
      b.setAttribute('aria-expanded', aberto);
    });
  });

  window.KLASSEY_TEMA = { real: real, semAcento: semAcento };
})();
